import React, { useEffect } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { updateAllotment } from "./api";
const Payment = () => {
    const navigate = useNavigate();
    const { ...params } = useParams()

    useEffect(() => {
        update()
    }, [])

    const update = async () => {
        let data = await updateAllotment(params.id)
    }

    return (
        <>
            <div className="card  application-box">
                <div className="card-header">
                    <div className='card-header-container'>
                        <div>
                            <Link to='/application'>
                                <button type="button" className="btn btn-warning btn-sm"><i className='fa fa-arrow-left'></i>&nbsp;Application</button>
                            </Link>
                        </div>
                        <div>
                            <i className='fa fa-credit-card'></i> Payment Info
                        </div>
                    </div>
                </div>
                <div id="applications" className='application-body application-form-box'>
                    <div className='card application-form'>
                        <h2 className="ui_section_title">Payment Details</h2>
                        {/* <p align="center"><i style={{ color: 'red', fontSize: '16px' }}>Your payment is successful. Click the link below to view and download admit card</i></p> */}
                        <br />
                        <p align="center">Your payment is successful. Click the link below to view and download admit card</p>
                    </div>
                </div>
                <div className="d-grid gap-2">
                    <button onClick={() => navigate("/exam")} className="btn btn-primary" type="button"><i className="fa fa-credit-card"></i>&nbsp;View Admit Card</button>
                </div>
            </div>
            <br />
            <br /><br />
        </>
    )
}

export default Payment